import { useState, useEffect, useRef, useCallback } from 'react';
import { Tooltip, TooltipContent, TooltipTrigger, TooltipProvider } from '@/components/ui/tooltip';

interface TruncatedValueProps {
  value?: string;
  children?: React.ReactNode;
  className?: string;
  wrapperClassName?: string;
}

export function TruncatedValue({ value, children, className = '', wrapperClassName = 'max-w-[65%] flex-1 flex justify-end min-w-0' }: TruncatedValueProps) {
  const ref = useRef<HTMLDivElement>(null);
  const [isTruncated, setIsTruncated] = useState(false);

  const checkTruncation = useCallback(() => {
    const el = ref.current;
    if (el) setIsTruncated(el.scrollWidth > el.clientWidth);
  }, []);

  useEffect(() => {
    checkTruncation();
    window.addEventListener('resize', checkTruncation);
    return () => window.removeEventListener('resize', checkTruncation);
  }, [checkTruncation, value, children]);

  const content = children || value;
  const wrapper = (
    <div ref={ref} className={`font-medium truncate text-right w-full cursor-default ${className}`}>
      {content}
    </div>
  );

  return (
    <div className={wrapperClassName}>
      {!isTruncated ? wrapper : (
        <TooltipProvider delayDuration={300}>
          <Tooltip>
            <TooltipTrigger asChild>{wrapper}</TooltipTrigger>
            <TooltipContent side="top">
              {value}
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      )}
    </div>
  );
}
